export function updateActiveView(activeView) {
  return {
    type: "UPDATE_ACTIVE_VIEW",
    activeView,
  }
}
